module.exports = __webpack_public_path__ + "static/media/webdesign-services-img43.3ab321bc.jpg";